import { ApolloClient, InMemoryCache, from, gql } from "@apollo/client";
import { createFragmentRegistry } from "@apollo/client/cache";

import { BANK_ACCOUNT_FRAGMENT, BANK_LINK_FRAGMENT, USER_FRAGMENT } from "@graphql";
import { mergePaginatedTransactions } from "@utils/transfers";
import { authLink, errorLink, httpLink } from "./links";

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        transactions: {
          keyArgs: ["$time"],
          merge: mergePaginatedTransactions,
        },
      },
    },
    Account: {
      keyFields: false,
    },
  },
  fragments: createFragmentRegistry(gql`
    ${USER_FRAGMENT}
    ${BANK_ACCOUNT_FRAGMENT}
    ${BANK_LINK_FRAGMENT}
  `),
});

export const client = new ApolloClient({
  cache,
  link: from([authLink, errorLink, httpLink]),
  name: `FutureMoney-Web`,
});
